import { DEFAULT_SITE } from './siteDefaults';

function strPrefer(a, b, fallback) {
  if (typeof a === 'string' && a.trim()) return a.trim();
  if (typeof b === 'string' && b.trim()) return b.trim();
  return typeof fallback === 'string' ? fallback : '';
}

const FALLBACK_LOGO_URL =
  'https://res.cloudinary.com/dnw8qhp3h/image/upload/v1775968208/WhatsApp_Image_2026-04-12_at_10.13.22_AM_vzenep.jpg';
const FALLBACK_LOGO_ALT = 'Rafid Seeds logo';
const FALLBACK_BRAND_PRIMARY = 'Rafid';
const FALLBACK_BRAND_SECONDARY = 'Seeds';
const FALLBACK_BRAND_HREF = '/';
const FALLBACK_NAV_LINKS = [
  { label: 'Home', href: '#', current: true, dropdown: false },
  { label: 'About Us', href: '/about', current: false, dropdown: false },
  { label: "Founder's desk", href: '#founders-desk', current: false, dropdown: false },
  { label: 'Products', href: '#products', current: false, dropdown: false },
  { label: 'Gallery', href: '/gallery', current: false, dropdown: false },
  {
    label: 'Blog',
    href: '#blog',
    current: false,
    dropdown: true,
    dropdownSource: 'custom',
    dropdownItems: [{ label: 'Latest posts', href: '#blog' }],
  },
];

function normalizeDropdownItem(raw, fallback) {
  const r = raw && typeof raw === 'object' ? raw : {};
  const f = fallback && typeof fallback === 'object' ? fallback : {};
  return {
    label: strPrefer(r.label, f.label, ''),
    href: strPrefer(r.href, f.href, '#'),
  };
}

function normalizeNavLink(raw, fallback) {
  const r = raw && typeof raw === 'object' ? raw : {};
  const f = fallback && typeof fallback === 'object' ? fallback : {};
  const href = strPrefer(r.href, f.href, '#');
  const dropdown = typeof r.dropdown === 'boolean' ? r.dropdown : Boolean(f.dropdown);
  let dropdownSource = typeof r.dropdownSource === 'string' ? r.dropdownSource.trim() : '';
  if (dropdownSource !== 'seedCategories' && dropdownSource !== 'custom') dropdownSource = '';
  if (!dropdown) dropdownSource = '';
  const fItems = Array.isArray(f.dropdownItems) ? f.dropdownItems : [];
  const rItems = Array.isArray(r.dropdownItems) ? r.dropdownItems : [];
  let dropdownItems = [];
  if (dropdown && dropdownSource === 'custom') {
    dropdownItems = rItems
      .map((row, i) => normalizeDropdownItem(row, fItems[i]))
      .filter((row) => row.label && row.href)
      .slice(0, 20);
  }
  // Legacy CMS rows: "dropdown" true but no source — Crops-style links use href "#".
  if (dropdown && !dropdownSource && href === '#') {
    dropdownSource = 'seedCategories';
  }
  return {
    label: strPrefer(r.label, f.label, 'Link'),
    href,
    current: typeof r.current === 'boolean' ? r.current : Boolean(f.current),
    dropdown,
    dropdownSource,
    dropdownItems,
  };
}

/** Category rows for nav dropdowns; prefers CMS `seedVarieties.categories`, else derives from families. */
export function resolveSeedVarietyCategories(site) {
  const raw = site?.seedVarieties?.categories;
  if (Array.isArray(raw) && raw.length) {
    return raw
      .map((c) => ({
        id: typeof c?.id === 'string' ? c.id.trim() : '',
        name: typeof c?.name === 'string' ? c.name.trim() : '',
        summary: typeof c?.summary === 'string' ? c.summary.trim() : '',
        heroImage: typeof c?.heroImage === 'string' ? c.heroImage.trim() : '',
      }))
      .filter((c) => c.id && c.name);
  }
  const fam = site?.seedVarieties?.families;
  if (!Array.isArray(fam) || !fam.length) return [];
  const byId = new Map();
  for (const p of fam) {
    const id = typeof p?.categoryId === 'string' ? p.categoryId.trim() : '';
    if (!id || byId.has(id)) continue;
    const name =
      typeof p?.categoryName === 'string' && p.categoryName.trim()
        ? p.categoryName.trim()
        : id;
    byId.set(id, { id, name });
  }
  return [...byId.values()];
}

/** Header identity + nav links from API / bundled defaults. */
export function resolveHeader(site) {
  const d = DEFAULT_SITE.header && typeof DEFAULT_SITE.header === 'object' ? DEFAULT_SITE.header : {};
  const x = site?.header && typeof site.header === 'object' ? site.header : {};
  const defaultLinks = Array.isArray(d.navLinks) && d.navLinks.length ? d.navLinks : FALLBACK_NAV_LINKS;
  const linksRaw = Array.isArray(x.navLinks) && x.navLinks.length ? x.navLinks : defaultLinks;
  const navLinks = linksRaw
    .slice(0, 10)
    .map((row, i) => normalizeNavLink(row, defaultLinks[i] || FALLBACK_NAV_LINKS[i % FALLBACK_NAV_LINKS.length]))
    .filter((row) => row.label && row.href);
  return {
    logoUrl: strPrefer(x.logoUrl, d.logoUrl, FALLBACK_LOGO_URL),
    logoAlt: strPrefer(x.logoAlt, d.logoAlt, FALLBACK_LOGO_ALT),
    brandPrimary: strPrefer(x.brandPrimary, d.brandPrimary, FALLBACK_BRAND_PRIMARY),
    brandSecondary: strPrefer(x.brandSecondary, d.brandSecondary, FALLBACK_BRAND_SECONDARY),
    brandHref: strPrefer(x.brandHref, d.brandHref, FALLBACK_BRAND_HREF),
    navLinks: navLinks.length ? navLinks : FALLBACK_NAV_LINKS,
  };
}
